import { useMemo } from 'react';
import { ShopTypes } from '~/lib/data-contract';
import { useCurrency } from '~/shared/hooks';

export default function useCsvExport(data: ShopTypes.CustomerInfoHeader[]) {
    const columnsCsv = [
        {
            id: 'invoiceDate',
            displayName: 'Dato',
        },
        {
            id: 'invoiceNumber',
            displayName: 'Bilag',
        },
        {
            id: 'customerOrderNumber',
            displayName: 'Eget ordrenummer',
        },
        {
            id: 'state',
            displayName: 'Status',
        },
        {
            id: 'invoiceAmount',
            displayName: 'Beløb',
        },
        {
            id: 'remainingAmount',
            displayName: 'Udestående',
        },
        {
            id: 'customerReference',
            displayName: 'Sagsreference',
        },
        {
            id: 'dueDate',
            displayName: 'Forfaldsdato',
        },
    ];
    const formatCurrency = useCurrency(false);

    const csvData = useMemo(() => {
        if (!data) return [];

        return data.map((item) => {
            return {
                invoiceDate: item.invoiceDate
                    ? new Date(item.invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
                customerOrderNumber: item.customerOrderNumber
                    ? item.customerOrderNumber.toString()
                    : '',
                invoiceNumber: item.invoiceNumber,
                state: item.status?.description,
                invoiceAmount: formatCurrency(item.invoiceAmount).toString(),
                remainingAmount: formatCurrency(item.remainingAmount).toString(),
                customerReference: item.customerReference ? item.customerReference.toString() : '',
                dueDate: item.dueDate
                    ? new Date(item.dueDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                    : '',
            };
        });
    }, [data, formatCurrency]);

    return { columnsCsv, csvData };
}
